import { Navigate, useParams } from "react-router-dom";

export default function InviteRedirect() {
  const { code } = useParams<{ code: string }>();
  return <Navigate to={`/auth/signup?ref=${code || ""}`} replace />;
}
